import React, { useState, useEffect } from 'react';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider } from 'semantic-ui-react';
import { api } from '../../../services/api';

import Navbarr from '../../../components/Navbar';
import { getUser } from '../../../services/auth';

export default function StoreCreate({ sidebar: Sidebar}) {
    const [storeStates, setStoreStates] = useState({
        formStore: {
            nome: '',
            endereco: '',
            rotas: [],
            produtos: [],
            admins: []
        },
        productsOptions: [],
        routesOptions: [],
        isLoading: false
    });

    const username = getUser();

    const resetStoreStates = () => {
        setStoreStates( prevState => ({
            ...prevState,
            formStore: {
                nome: '',
                endereco: '',
                rotas: [],
                produtos: [],
                admins: []
            },
            //productsOptions: [],
            //routesOptions: [],
            isLoading: false
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setStoreStates( prevState => ({
            ...prevState,
            formStore: {
                ...prevState['formStore'],
                nome: value
            }
        }));
    }

    const handleEndChange = (e, {value}) => {
        setStoreStates( prevState => ({
            ...prevState,
            formStore: {
                ...prevState['formStore'],
                endereco: value
            }
        }));
    }

    const handleProductChange = (e, {value}) => {
        setStoreStates((prevState) => ({
            ...prevState,
            formStore: {
                ...prevState['formStore'],
                produtos: value
            }
        }));
    }

    const handleRotaChange = (e, {value}) => {
        setStoreStates((prevState) => ({
            ...prevState,
            formStore: {
                ...prevState['formStore'],
                rotas: value
            }
        }));
    }

    async function handlePost() {
        try {
            setStoreStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));
            const rotas = [];
            const produtos = [];

            storeStates['formStore']['rotas'].forEach(
                route => rotas.push({'id':route})
            );

            storeStates['formStore']['produtos'].forEach(
                produto => produtos.push({'id':produto})
            );

            //console.log(storeStates['formStore']['nome']);
            //console.log(storeStates['formStore']['endereco']);
            //console.log(rotas);
            //console.log(produtos);
            //console.log([{"email": username}]);

            /*const data = */await api.postStore(storeStates['formStore']['nome'],
                                            storeStates['formStore']['endereco'],
                                            rotas, produtos, [{"email": username}]);
            Alert.success("Loja cadastrada com sucesso!");
            resetStoreStates();
        } catch (err) {
            Alert.error("Falha ao cadastrar loja. Verifique os campos e tente novamente.");
            console.error('Falha ao cadastrar loja: ', err);
            setStoreStates( prevState=> ({
                ...prevState,
                isLoading: false,
            }));
        }
    }

    useEffect(() => {

        async function fetchProducts() {
            try {
                const productsOptions = [];
                const products = await api.getOwnProducts();
                products.forEach(
                    prod => {
                        productsOptions.push({key: prod['id'],
                                            text: prod['nome'],
                                            value: prod['id']});
                    }
                );
                setStoreStates(prevState => ({
                    ...prevState,
                    products: products,
                    productsOptions: productsOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter produtos: ',err);
            }
        }

        async function fetchRoutes() {
            try {
                const routesOptions = [];
                const routes = await api.getRoutes();
                routes.forEach(
                    route => {
                        routesOptions.push({key: route['id'],
                                            text: route['nome'],
                                            value: route['id']});
                    }
                );
                setStoreStates(prevState => ({
                    ...prevState,
                    routesOptions: routesOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter rotas: ', err);
            }
        }

        fetchProducts();
        fetchRoutes();
    },[]);

    return (
        <Container className="s-content">
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"storenew"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <div>
                        <Segment
                            loading={storeStates['isLoading']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Nova Loja
                            </Header>

                            <Divider clearing />
                            Preencha os campos com as informações da loja
                            <Form style={{marginTop: '15px'}}>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            iconPosition='left'
                                            icon='home'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={storeStates['formStore']['nome']}
                                            onChange={handleNomeChange}
                                        />
                                        <Form.Input
                                            iconPosition='left'
                                            icon='map marker alternate'
                                            fluid label='Endereço'
                                            placeholder='Endereço'
                                            value={storeStates['formStore']['endereco']}
                                            onChange={handleEndChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown rotas*/}
                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Rotas</label>
                                        </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={storeStates['routesOptions']}
                                            placeholder='Escolha rotas'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={storeStates['formStore']['rotas']}
                                            onChange={handleRotaChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown produtos*/}
                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                        <label>Produtos</label>
                                    </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={storeStates['productsOptions']}
                                            placeholder='Escolha produtos'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={storeStates['formStore']['produtos']}
                                            onChange={handleProductChange}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            size="mini"
                                            floated='right'
                                            onClick={handlePost}
                                            type='submit'>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </div>
                    </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
